import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
import LazyLoad from "react-lazyload";  
const SeniorWing = () => {  
  useEffect(() => {
    document.title = 'Senior Wing - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Prospectus</li>
                    <li>Senior Wing</li>
                </ul>
            </div> 
            <section className="innerbody innerimgdec">
            <div className="container"> 
                    <div className="row"> 
                    <div className="col-lg-12">
                    <p>
                    St. Francis Xavier designs and implements its own curriculum based on guidelines and tries to ensure
                    that
                    the students and teachers have as much flexibility as possible to foster child-centered learning.
                    The
                    school encourages flexibility of methodology and the use of experiential learning systems, which
                    help
                    eliminate rote learning and develop a healthy, positive attitude towards learning. Our system
                    considers the individualities of different children to provide adequate feedback on their
                    learning without putting undue pressure. The introduction of CCE (Continuous Comprehensive
                    Evaluation) is a further step in this direction.
                </p>
                     </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                 <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/senior_1.jpg" className="img-fluid" alt="sfxhisar"/></LazyLoad>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                 <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/senior_2.jpg" className="img-fluid" alt="sfxhisar"/></LazyLoad>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                 <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/senior_3.jpg" className="img-fluid" alt="sfxhisar"/></LazyLoad>
            </div>
                    </div>
                    </div>  
           </section>
           <Footer/>
        </>
    );
}

export default SeniorWing;
